<div class="flex justify-end">
  <div
    [ngStyle]="bubbleStyles()"
    class="max-w-4/5 rounded-[18px] rounded-br-none bg-(--bubble-bg) p-4"
  >
    <p class="text-label font-normal leading-normal text-(--bubble-text) wrap-break-word">
      {{ message() }}
    </p>
  </div>
</div>
